import { useCallback } from "react";

import type { ColumnFactoryList } from "app/pages/sales-intelligence/common-components/search-results-table";
import type {
    LeadsSearchResponseDto,
    LeadsSearchTableData,
    LeadsSearchRow,
    LeadsType,
    TableColumnTypeDto,
} from "app/pages/sales-intelligence/modules/leads-search";
import type { ColumnAdapterContext } from "app/pages/sales-intelligence/modules/leads-search/types/columns";

import { fromDtoToColumnsConfig } from "../../utils/columns";
import { transformRowDto } from "../../utils/rows";

type HookValue = (data: LeadsSearchResponseDto) => LeadsSearchTableData<LeadsSearchRow>;

export const useLeadsSearchTransformData = (
    columnConfig: ColumnFactoryList<LeadsSearchRow, string, TableColumnTypeDto, ColumnAdapterContext>,
    leadsType: LeadsType,
): HookValue => {
    return useCallback(
        (data: LeadsSearchResponseDto): LeadsSearchTableData<LeadsSearchRow> => ({
            ...data,
            rows: transformRowDto(data.rows),
            columns: fromDtoToColumnsConfig(data.columns, columnConfig, { leadsType }),
        }),
        [columnConfig, leadsType],
    );
};
